import Select from '@/components/DSE/Select';
import { validatorRequire } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    finish1ID: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'invalidFinishCombination.finish1',
        valueField: 'id',
        labelField: 'description',
        loading: vue.$store.getters['finish/isLoading'],
        options: vue.$store.getters['finish/loadedItems']
      },
      rules: [{ validator: validatorRequire }]
    },
    finish2ID: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'invalidFinishCombination.finish2',
        valueField: 'id',
        labelField: 'description',
        loading: vue.$store.getters['finish/isLoading'],
        options: vue.$store.getters['finish/loadedItems']
      },
      rules: [{ validator: validatorRequire }]
    }
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
